/*
  1/10: "På lager"-filter på kollektionssider.

  Ren client-side toggle (indgår ikke i selve filter-formularen/URL'en). Data kommer fra et JSON-datasæt pr.
  grid-item (data-collection-stock-json-attributtet, se snippets/product-grid-item.liquid), beregnet ud fra
  variant.inventory_quantity (ikke variant.available), fordi EMMI&CO. har "fortsæt salg ved udsolgt" slået til
  på sporede varianter.

  Adfærd (låst fast med Mads via spørgsmål 1/10, udvidet samme dag efter en fundet fejl - se nedenfor):
  - Er der valgt værdier i ét eller flere options-baserede filtre (fx "Str." OG "Metal" på samme tid), skjules
    produkter, der ikke har PRÆCIS ÉN variant på lager, som matcher ALLE de valgte værdier på tværs af alle
    aktive filtre samtidig - helt fra gitteret (ikke nedtonet, som på produktsiden).
  - Er der ikke valgt noget i noget options-baseret filter overhovedet, skjules produkter der slet ikke har
    lager i nogen variant.

  Fejl fundet og rettet 1/10, samme dag: første version tjekkede kun lager pr. størrelsesværdi (Ringstørrelse/
  Brede/Længde), helt uafhængigt af andre samtidigt valgte filtre. Det viste fx en ring som "på lager" i str.
  52, selvom str. 52 kun var på lager i et andet metal (Guld) end det, kunden også havde valgt i "Metal"-
  filteret (Hvidguld) - de to filtre blev tjekket hver for sig i stedet for på den samme variant. Rettet ved at
  kræve, at ÉN OG SAMME variant opfylder ALLE aktive options-filtre samtidig (matchesActiveFilters nedenfor), i
  stedet for at behandle hver filter-dimension isoleret. Generaliseret så det automatisk dækker ethvert
  options-baseret filter (name="filter.v.option.*"), ikke kun Str. og Metal specifikt.

  Toggle-boksen ligger inde i collection-filters-form.js' egen sidebar (data-collection-sidebar), som bliver
  fuldstændig gen-renderet (innerHTML) hver gang et RIGTIGT filter ændres. Derfor:
  - Toggle'ens egen 'input'-event stopper propagation, så den ikke selv trigger collection-filters-form.js'
    AJAX-genindlæsning af sidebar + gitter.
  - Toggle'en er placeret UDENFOR selve <form data-collection-filters-form> i snippets/filters.liquid, fordi
    collection-filters-form.js nulstiller formularen (native form.reset()) som led i sin AJAX-flow - det ramte
    også vores checkbox (den har ikke noget "name", men lå stadig fysisk inde i <form>), og nulstillede den
    lige efter vi selv havde gendannet dens tilstand.
  - En MutationObserver overvåger sektionen (kun childList/subtree, ikke attributes) for at opdage når AJAX-
    udskiftningen sker, med en kort trailing debounce (setTimeout, ikke requestAnimationFrame - som kan blive
    strupet/aldrig fyre i en baggrundsfane), så vi venter til BÅDE sidebar- og gitter-udskiftningen er faldet
    til ro, før vi geninitialiserer os selv (finder den nye checkbox, gendanner dens checked-tilstand, og
    genanvender filtreringen på det nye gitter) - uden selv at trigge observeren, da filtreringen kun sætter
    et hidden-attribut på grid-items, hvilket ikke er en childList-ændring.

  1/10 (sen eftermiddag, rev. 4): Mads ønskede, at når "På lager"-toggle'en er slået til, skal de ANDRE
  filtermuligheder i sidebaren (Metal/Str./Carat) også vise, hvilke af deres værdier der reelt er muligt at
  kombinere med det, kunden allerede har valgt - fx hvis man vælger Str. "54", skal Carat-værdier, der ikke
  findes på lager i str. 54, streges over, ligesom "Vis kun varianter på lager" allerede gør på selve
  produktsiden (assets/product-stock-filter.js - samme visuelle sprog, samme stock-filter--out-klasse,
  genbruger eksisterende CSS fra 30/9). Beregningen (applySidebarFacets) genbruger de samme per-produkt
  data-collection-stock-json-datasæt, der allerede bruges til selve gitter-filtreringen ovenfor, aggregeret på
  tværs af ALLE grid-items i den aktuelle sidebar (dvs. alle produkter, der matcher Smykketype/Pris og de
  øvrige allerede aktive options-filtre - det er netop den delmængde, Shopifys egen AJAX allerede har
  indsnævret til, siden vi kører efter en rigtig filter-ændring). For hver options-baseret filterværdi tjekkes,
  om ÉN ELLER ANDEN variant på tværs af de produkter har lager OG matcher denne værdi SAMT alle andre aktive
  filtre (undtagen værdiens egen gruppe - standard "facet-udelukker-sig-selv"-mønster, så allerede valgte
  værdier i samme gruppe ikke forsvinder). Str.-gruppens tre dimensioner (Ringstørrelse/Brede/Længde) er
  "master", ligesom på produktsiden: de nedtones KUN hvis værdien slet ikke findes på lager nogen steder - de
  nedtones ikke af et Metal/Carat-valg - mens Metal og Carat nedtoner hinanden gensidigt ift. den fulde
  kombination (inkl. en evt. valgt størrelse), igen samme regel som produktsiden.
*/
(function () {
  'use strict';

  var OPTION_FILTER_PREFIX = 'filter.v.option.';

  // 1/10 (sen eftermiddag, rev. 4): samme "master"-tankegang som sizeOptionPosition på produktsiden
  // (assets/product-stock-filter.js) - de tre størrelsesdimensioner, der samles under "Str." i sidebaren
  // (snippets/filters.liquid), navngivet efter samme lowercase produkt-options-navn som optionPositions
  // bruger (ikke filterets evt. rettede visningslabel - fx er selve produkt-optionen "Brede", selvom
  // filterets label er rettet til "Bredde").
  var SIZE_OPTION_NAMES = ['ringstørrelse eu size', 'brede', 'længde'];

  var wasChecked = false;
  var debounceHandle = null;

  function getGridItems(section) {
    var gridOuter = section.querySelector('[data-products-grid]');
    if (!gridOuter) return [];
    return Array.prototype.slice.call(gridOuter.querySelectorAll('[data-grid-item]'));
  }

  function getActiveOptionFilters(section) {
    var selector = 'input[type="checkbox"]:checked[name^="' + OPTION_FILTER_PREFIX + '"]';
    var checked = section.querySelectorAll(selector);
    var active = {};

    Array.prototype.forEach.call(checked, function (input) {
      var optionName = input.name.slice(OPTION_FILTER_PREFIX.length).toLowerCase();
      if (!active[optionName]) {
        active[optionName] = [];
      }
      active[optionName].push(input.value);
    });

    return active;
  }

  function parseStockData(item) {
    var raw = item.getAttribute('data-collection-stock-json');
    if (!raw) return null;

    try {
      return JSON.parse(raw);
    } catch (e) {
      return null;
    }
  }

  function matchesActiveFilters(variant, optionPositions, activeFilters) {
    for (var optionName in activeFilters) {
      if (!Object.prototype.hasOwnProperty.call(activeFilters, optionName)) continue;

      var position = optionPositions[optionName];
      if (position === undefined) continue; // produktet har ikke denne option - begræns ikke på den

      var allowedValues = activeFilters[optionName];
      if (allowedValues.indexOf(variant.o[position]) === -1) {
        return false;
      }
    }
    return true;
  }

  function itemHasMatchingStock(item, activeFilters, hasActiveFilters) {
    var data = parseStockData(item);
    if (!data || !data.variants) return false;

    if (!hasActiveFilters) {
      return data.variants.some(function (v) {
        return v.s;
      });
    }

    var optionPositions = data.optionPositions || {};

    return data.variants.some(function (v) {
      return v.s && matchesActiveFilters(v, optionPositions, activeFilters);
    });
  }

  function isSizeOption(optionName) {
    return SIZE_OPTION_NAMES.indexOf(optionName) !== -1;
  }

  function collectAllVariants(items) {
    var all = [];

    items.forEach(function (item) {
      var data = parseStockData(item);
      if (!data || !data.variants) return;

      var optionPositions = data.optionPositions || {};

      data.variants.forEach(function (variant) {
        all.push({ v: variant, optionPositions: optionPositions });
      });
    });

    return all;
  }

  function valueHasStock(allVariants, optionName, value, activeFilters) {
    for (var i = 0; i < allVariants.length; i++) {
      var entry = allVariants[i];
      var position = entry.optionPositions[optionName];

      if (position === undefined) continue; // dette produkt har slet ikke denne option
      if (!entry.v.s) continue;
      if (entry.v.o[position] !== value) continue;

      if (isSizeOption(optionName)) {
        // Master-dimension: findes værdien på lager i ÉN ELLER ANDEN kombination overhovedet,
        // uanset hvad der ellers er valgt i Metal/Carat - se kommentaren foroven.
        return true;
      }

      var matchesRest = true;
      for (var otherName in activeFilters) {
        if (!Object.prototype.hasOwnProperty.call(activeFilters, otherName)) continue;
        if (otherName === optionName) continue; // facetten udelukker sin egen aktive værdi

        var otherPosition = entry.optionPositions[otherName];
        if (otherPosition === undefined) continue;

        if (activeFilters[otherName].indexOf(entry.v.o[otherPosition]) === -1) {
          matchesRest = false;
          break;
        }
      }

      if (matchesRest) return true;
    }

    return false;
  }

  function applySidebarFacets(section, items, activeFilters) {
    var allVariants = collectAllVariants(items);
    var selector = 'input[type="checkbox"][name^="' + OPTION_FILTER_PREFIX + '"]';
    var checkboxes = section.querySelectorAll(selector);

    Array.prototype.forEach.call(checkboxes, function (input) {
      var optionName = input.name.slice(OPTION_FILTER_PREFIX.length).toLowerCase();
      var li = input.closest('.sidebar__item');
      if (!li) return;

      var hasStock = valueHasStock(allVariants, optionName, input.value, activeFilters);
      li.classList.toggle('sidebar__item--stock-out', !hasStock);
    });
  }

  function clearSidebarFacets(section) {
    var marked = section.querySelectorAll('.sidebar__item--stock-out');
    Array.prototype.forEach.call(marked, function (li) {
      li.classList.remove('sidebar__item--stock-out');
    });
  }

  function applyFilter(section) {
    var checkbox = section.querySelector('[data-collection-stock-filter-checkbox]');
    var emptyMessage = section.querySelector('[data-collection-stock-filter-empty]');
    var items = getGridItems(section);

    if (!checkbox || !checkbox.checked) {
      items.forEach(function (item) {
        item.removeAttribute('hidden');
      });

      if (emptyMessage) {
        emptyMessage.hidden = true;
      }

      clearSidebarFacets(section);
      return;
    }

    var activeFilters = getActiveOptionFilters(section);
    var hasActiveFilters = Object.keys(activeFilters).length > 0;
    var visibleCount = 0;

    items.forEach(function (item) {
      var matches = itemHasMatchingStock(item, activeFilters, hasActiveFilters);

      if (matches) {
        item.removeAttribute('hidden');
        visibleCount += 1;
      } else {
        item.setAttribute('hidden', '');
      }
    });

    if (emptyMessage) {
      emptyMessage.hidden = visibleCount > 0;
    }

    applySidebarFacets(section, items, activeFilters);
  }

  function bindCheckbox(section) {
    var checkbox = section.querySelector('[data-collection-stock-filter-checkbox]');
    if (!checkbox) return;

    checkbox.checked = wasChecked;

    checkbox.addEventListener('input', function (event) {
      event.stopPropagation();
      wasChecked = checkbox.checked;
      applyFilter(section);
    });

    checkbox.addEventListener('click', function (event) {
      event.stopPropagation();
    });
  }

  function init(section) {
    bindCheckbox(section);
    applyFilter(section);
  }

  function watch(section) {
    var observer = new MutationObserver(function () {
      if (debounceHandle) {
        window.clearTimeout(debounceHandle);
      }

      debounceHandle = window.setTimeout(function () {
        debounceHandle = null;
        init(section);
      }, 80);
    });

    observer.observe(section, { childList: true, subtree: true });
  }

  function start() {
    var sections = document.querySelectorAll('[data-section-type="collection"]');

    Array.prototype.forEach.call(sections, function (section) {
      init(section);
      watch(section);
    });
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', start);
  } else {
    start();
  }
})();
